var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _path7, _circle4, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle5, _circle6, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _circle7, _path22, _circle8, _path23, _path24, _path25;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 936 604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M69 558c-12-4-18 15-5 19s18-16 5-19Zm71 24c-13-3-18 16-6 20 13 3 18-16 6-20Zm28-202-33 88-4-1 33-89a6 6 0 0 1 5-6c16-3 23 12 23 12l-34 91-4-2 32-88c-9-9-18-5-18-5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M130 587c-19 0-43-10-59-18a20 20 0 0 1-11-24l21-75a25 25 0 0 1 13-15 24 24 0 0 1 19-2 2386 2386 0 0 0 49 14c1 0 15 5 12 22-2 14-16 63-23 83a22 22 0 0 1-20 15h-1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m71 557 27-93 64 19v-2l-65-18-28 93 2 1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e5e5",
    d: "M375 15h561v266H375z",
    "data-name": "Rectangle 62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M392 38h529v222H392z",
    "data-name": "Rectangle 75"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M375 0h561v24H375z",
    "data-name": "Rectangle 80"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 392.3,
    cy: 11.9,
    r: 4.4,
    fill: "#fff",
    "data-name": "Ellipse 90"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 409.1,
    cy: 11.9,
    r: 4.4,
    fill: "#fff",
    "data-name": "Ellipse 91"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.9,
    cy: 11.9,
    r: 4.4,
    fill: "#fff",
    "data-name": "Ellipse 92"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M641 146a84 84 0 0 1-5 30 82 82 0 0 1-6 12 84 84 0 0 1-146 0l-2-4a84 84 0 1 1 159-38Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.4,
    cy: 144.4,
    r: 16.1,
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M482 184c7-7 16-20 25-11 5 4 12 15 18 8l53-52a10 10 0 0 1 15 0l43 47a82 82 0 0 1-6 12H484Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M814 130a2 2 0 0 0 0 4h23a2 2 0 0 0 0-4Z",
    "data-name": "Path 680"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e5e5",
    d: "M711 98a2 2 0 1 0 0 4h127a2 2 0 0 0 0-4Zm0 16a2 2 0 1 0 0 4h127a2 2 0 0 0 0-4Z",
    "data-name": "Path 680"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M814 232a2 2 0 0 0 0 5h23a2 2 0 1 0 0-5Z",
    "data-name": "Path 680"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e5e5",
    d: "M711 200a2 2 0 0 0 0 5h127a2 2 0 0 0 0-5Zm0 16a2 2 0 1 0 0 5h127a2 2 0 0 0 0-5Z",
    "data-name": "Path 680"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e5e5",
    d: "M787 73h-7l-6-8h-2l2 8h-6l-3-2h-2l1 5-1 4h2l3-3h7l-3 9h2l6-9h7a2 2 0 1 0 0-4Zm-6 111h-11a4 4 0 0 1-4-4v-10a3 3 0 0 1 3-3 27 27 0 0 1 13 0 3 3 0 0 1 3 3v10a4 4 0 0 1-4 4Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M769 170h14v5h-14z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 770.3,
    cy: 179.2,
    r: 1.8,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 780.8,
    cy: 179.2,
    r: 1.8,
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e5e5",
    d: "M784 189h-17l4-4h9Zm-14-1h11l-1-2h-9Zm15-4h-19a1 1 0 0 1 0-2h19a1 1 0 0 1 0 2Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb7b7",
    d: "M184 387a9 9 0 0 0-6-13l-1-32-14 10 4 29a9 9 0 0 0 17 6Zm105 6a9 9 0 0 1 4-13l-3-33 14 8 1 30a9 9 0 0 1-16 8Zm-80 199h11l5-41h-16v41z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M207 588h21a13 13 0 0 1 13 14h-34Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb7b7",
    d: "m263 585 11 3 13-40-15-3-9 40z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m261 581 21 5a13 13 0 0 1 10 16l-34-7Zm-71-225s-11 35 0 75l11 47 3 106 23-8 9-160 43 73-22 87 26 1 28-95-25-88-4-21Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "m283 239-23-13-39-2-28 14 11 77s-21 30-13 50c10 26 93 39 91 14-2-38-6-36-9-55-3-20 19-47 19-47Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "m202 246-3-11s-11 1-18 22l-21 66 1 16s-5 6-2 8-6 7-1 11a14 14 0 0 1 5 14l16-4-2-26 7-20 16-50Zm73 2 3-11s6-2 11 12 7 52 7 52l9 44s4 6 2 8 8 3 2 6 1 0-2 7v6l-17-3-5-23-11-42Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 184.1,
    r: 30.3,
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M237 165a64 64 0 0 0-23-15c-5-2-11-3-17-2s-12 5-13 11c-2 5 0 10 2 14l6 13a30 30 0 0 1-30 40l17 5c6 1 12 2 16-2 5-5 5-12 5-18l-1-27c0-5-1-9 1-14 2-4 6-8 10-8s7 2 10 4c3 3 6 5 9 5 4 0 8-2 7-6Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.5,
    cy: 343.4,
    r: 22.3,
    fill: "#ffb7b7",
    transform: "rotate(-61 185 381)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M275 194h-32l-1-5-1 5h-5l-1-10-3 10h-10v-1a24 24 0 0 1 24-24h5a24 24 0 0 1 24 24Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m227 210-12-12-2-26h26v1c-9 9-19 22-12 37Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "M382 604H1a1 1 0 0 1 0-2h381a1 1 0 0 1 0 2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.1bda7607071abf41e331758aaeae6bc0.svg";
export { ForwardRef as ReactComponent };